<script>
import required from "vuelidate/lib/validators/required";
import DatePicker from "vue2-datepicker";

export default {
  name: "ItemCategory",
  components: {
    DatePicker,
  },
  data() {
    return {
      submitted: false,
      tableData: [],
      modalTitle: "",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: "",
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "id",
          sortable: true,
          label: "Inventory",
        },
      ],
      form: {
        title: "",
        description: "",
        startDate: "",
      },
      indexSelected: -1,
      tableBusy: false,
    };
  },
  computed: {
    filtered() {
      let array = this.tableData;
      let keyword = this.filter;
      const regExp = new RegExp(keyword, "gi");
      const check = (obj) => {
        if (obj !== null && typeof obj === "object") {
          return Object.values(obj).some(check);
        }
        if (Array.isArray(obj)) {
          return obj.some(check);
        }
        return (
          (typeof obj === "string" || typeof obj === "number") &&
          regExp.test(obj)
        );
      };
      return array.filter(check);
    },
    rows() {
      if (this.filter.trim() != "" && this.filter) {
        return this.filtered.length;
      } else {
        return this.tableData.length;
      }
    },
  },
  validations: {
    form: {
      title: { required },
      description: { required },
      startDate: { required },
    },
  },
  methods: {
    getData() {
      this.tableBusy = true;
      this.$store
        .dispatch(
          "propertyinventory/GetPropertyInventory",
          this.$store.state.data.selectedCampus.id
        )
        .then((res) => {
          this.tableBusy = false;
          this.tableData = res.data.filter((item) => {
            return item.status == "ONGOING";
          });
        })
        .catch(() => {
          this.tableBusy = false;
          this.showToast(
            "Something went wrong - Getting inventory list!",
            "error"
          );
        });
    },
    onCreate() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.form.campusId = this.$store.state.data.selectedCampus.id
        this.form.startDate = this.getDate(this.form.startDate);
        this.$store
          .dispatch("propertyinventory/CreatePropertyInventory", this.form)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            this.tableData.push(res.data);
            this.onReset();
            this.$bvModal.hide("modal-create");
            this.showToast("Successfully created!", "success");
          })
          .catch((err) => {
            this.showToast(
              "Something went wrong - creating inventory!",
              "error"
            );
          });
        this.submitted = false;
      }
    },
    createInventory() {
      this.onReset();
      this.modalTitle = "Create Inventory";
      this.$bvModal.show("modal-create");
    },
    onReset() {
      this.submitted = false;
      this.form = {
        title: "",
        description: "",
        startDate: "",
      };
    },
    onRowSelected(data) {
      this.$emit("dropData", data[0]);
      this.$bvModal.hide("inventory-modal");
    },
  },
};
</script>
    
<template>
  <b-modal
    id="inventory-modal"
    title="Inventory List"
    size="lg"
    title-class="font-18"
    hide-footer
    no-close-on-backdrop
  >
    <!-- Create Inventory -->
    <b-modal
      id="modal-create"
      :title="modalTitle"
      size="md"
      title-class="font-18"
      hide-footer
    >
      <form @submit.prevent="onCreate" class="needs-validation" ref="fcForm">
        <div class="mb-3">
          <label for="title">Title </label>
          <input
            id="title"
            type="text"
            v-model="form.title"
            placeholder="Enter Title..."
            class="form-control"
            :class="{
              'is-invalid': submitted && $v.form.title.$error,
            }"
            autocomplete="off"
          />
          <div
            v-if="submitted && $v.form.title.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.form.title.required">This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="startDate">Start Date</label>
          <date-picker
            v-model="form.startDate"
            :first-day-of-week="1"
            lang="en"
            placeholder="Enter Start Date..."
            :class="{
              'is-invalid': submitted && $v.form.startDate.$error,
            }"
          ></date-picker>
          <div
            v-if="submitted && $v.form.startDate.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.form.startDate.required"
              >This value is required.</span
            >
          </div>
        </div>
        <div class="mb-3">
          <label for="description">Description </label>
          <textarea
            id="description"
            rows="2"
            v-model="form.description"
            placeholder="Enter Description..."
            class="form-control"
            autocomplete="off"
          ></textarea>
        </div>
        <div class="d-flex flex-row-reverse">
          <button type="submit" class="btn btn-primary">Create</button>
        </div>
      </form>
    </b-modal>
    <div class="row mt-1">
      <div class="col-sm-12 col-md-6">
        <div id="tickets-table_filter" class="dataTables_filter">
          <label class="d-inline-flex align-items-center">
            Search:
            <b-form-input
              autocomplete="off"
              v-model="filter"
              type="search"
              placeholder="Search..."
              class="form-control form-control-sm ms-2"
            ></b-form-input>
          </label>
        </div>
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="d-flex justify-content-end align-items-center">
          <button
            type="button"
            @click="createInventory()"
            class="btn btn-sm btn-info d-flex align-items-center"
          >
            <i class="bx bx-plus fs-6"></i>Create New
          </button>
        </div>
      </div>
      <!-- End search -->
    </div>
    <div class="table-responsive mb-0">
      <b-table
        class="datatables"
        :items="filtered"
        :fields="fields"
        responsive="sm"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :filter="filter"
        :filter-included-fields="filterOn"
        :busy="tableBusy"
        bordered
        outlined
        hover
        striped
        show-empty
        select-mode="single"
        selectable
        @row-selected="onRowSelected"
        selected-variant="success"
      >
        <template #empty="scope">
          <div class="text-center">{{ scope.emptyText }}</div>
        </template>
        <template #table-busy>
          <div class="d-flex justify-content-center align-items-center">
            <div class="preloader-component me-2">
              <div class="status">
                <div class="spinner-chase w-20px h-20px">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
            <strong>Loading...</strong>
          </div>
        </template>
        <template #cell(id)="row">
          <div>
            <b class="text-white font-size-14">{{ row.item.title }}</b>
            <div>
              <b>
                Start Date:
                {{ formatDate(new Date(row.item.startDate)) }}
              </b>
            </div>
            <div class="badge bg-success">
              <small class="font-size-10">{{ row.item.status }}</small>
            </div>
          </div>
        </template>
      </b-table>
    </div>
    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </b-modal>
</template>